import React from 'react';
import { z } from 'zod';
import { styled } from 'styled-components';
import type { BlockDefinition } from '../types';
import { markdownToSafeHtml } from '../md';

// Long-form legal content — Strapi sections.privacy-policy-content (a markdown
// richtext field). Rendered via markdownToSafeHtml (escape-first, safe subset),
// so no untrusted HTML reaches the DOM. Used by the privacy-policy pages.
export const privacyContentSchema = z.object({
  content: z.string().min(1),
});

type PrivacyContentProps = z.infer<typeof privacyContentSchema>;

const Prose = styled.div`
  max-width: 88rem;
  margin: 0 auto;
  padding: 4rem 1.6rem 6rem;
  color: #2b2f3a;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.6rem;
  line-height: 1.8;

  h1, h2, h3, h4, h5, h6 {
    margin: 3.2rem 0 1.2rem;
    color: #0b1020;
    font-family: 'Space Grotesk', sans-serif;
    line-height: 1.25;
  }
  h4 { font-size: 2rem; }
  h5 { font-size: 1.7rem; }
  h6 { font-size: 1.5rem; }
  p { margin: 0 0 1.6rem; }
  strong { color: #0b1020; }
  a {
    color: #063091;
    text-decoration: underline;
    text-underline-offset: 2px;
    word-break: break-word;
  }
  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 2.4rem auto;
    border-radius: 1rem;
  }
`;

function PrivacyContent({ content }: PrivacyContentProps) {
  return <Prose dangerouslySetInnerHTML={{ __html: markdownToSafeHtml(content) }} />;
}

export const privacyContentBlock: BlockDefinition<PrivacyContentProps> = {
  type: 'privacyContent',
  schema: privacyContentSchema,
  Renderer: PrivacyContent,
};
